const PhotoIcon = ({ ...props }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.02564 5.7433C6.31759 5.7433 5.74359 6.3173 5.74359 7.02535V24.9741C5.74359 25.6821 6.31759 26.2561 7.02564 26.2561H24.9744C25.6824 26.2561 26.2564 25.6821 26.2564 24.9741V7.02535C26.2564 6.3173 25.6824 5.7433 24.9744 5.7433H7.02564ZM3.17949 7.02535C3.17949 4.90118 4.90147 3.1792 7.02564 3.1792H24.9744C27.0985 3.1792 28.8205 4.90118 28.8205 7.02535V24.9741C28.8205 27.0982 27.0985 28.8202 24.9744 28.8202H7.02564C4.90147 28.8202 3.17949 27.0982 3.17949 24.9741V7.02535Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.2217 12.5293C20.7223 12.0286 21.5341 12.0286 22.0348 12.5293L28.445 18.9396C28.9457 19.4402 28.9457 20.252 28.445 20.7527C27.9443 21.2533 27.1326 21.2533 26.6319 20.7527L21.1282 15.249L7.93219 28.445C7.43152 28.9456 6.61977 28.9456 6.1191 28.445C5.61842 27.9443 5.61842 27.1325 6.1191 26.6319L20.2217 12.5293Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5128 10.8717C11.1588 10.8717 10.8718 11.1587 10.8718 11.5127C10.8718 11.8668 11.1588 12.1538 11.5128 12.1538C11.8669 12.1538 12.1538 11.8668 12.1538 11.5127C12.1538 11.1587 11.8669 10.8717 11.5128 10.8717ZM8.30769 11.5127C8.30769 9.7426 9.74268 8.30762 11.5128 8.30762C13.283 8.30762 14.7179 9.7426 14.7179 11.5127C14.7179 13.2829 13.283 14.7179 11.5128 14.7179C9.74268 14.7179 8.30769 13.2829 8.30769 11.5127Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default PhotoIcon;
